import {Banner} from '@primer/react'

import type {AbuseReportBannerPayload} from './types'

/**
 * Warning banner shown to repository admins when the public repository has unresolved
 * abuse reports. It links to the reported content page where the reports can be
 * reviewed and resolved.
 */
export function AbuseReportBanner({unresolvedReportCount, reportedContentUrl}: AbuseReportBannerPayload) {
  // The server only surfaces this banner when there are unresolved reports, but
  // guard against a zero/negative count so we never render an empty warning.
  if (unresolvedReportCount <= 0) return null

  const reportNoun = unresolvedReportCount === 1 ? 'report' : 'reports'

  return (
    <Banner
      variant="warning"
      title={`You have ${unresolvedReportCount} unresolved abuse ${reportNoun}.`}
      flush
      primaryAction={
        <Banner.PrimaryAction as="a" href={reportedContentUrl}>
          {`View ${reportNoun}`}
        </Banner.PrimaryAction>
      }
    />
  )
}
